export default "__VITE_ASSET__0a4db91a__"